import { render, staticRenderFns } from "./StudentVideoList.vue?vue&type=template&id=d3770a98&scoped=true&"
import script from "./StudentVideoList.vue?vue&type=script&lang=js&"
export * from "./StudentVideoList.vue?vue&type=script&lang=js&"
import style0 from "./StudentVideoList.vue?vue&type=style&index=0&id=d3770a98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3770a98",
  null
  
)

export default component.exports